import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from 'lodash';
import {AgentLinkItem} from '../../utils/account-preferred-agents.util';


export class AccountAgentLinksCtrl implements IController {

  agents: AgentLinkItem[];

  public tooltip: string;

  $onChanges(changes) {
    if (changes.agents) {
      this.tooltip = _.map(this.agents, 'name').join(', ');
    }
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountAgentLinks', {
    bindings: {
      agents: '<'
    },
    template: require('./account-agent-links.html').default,
    controller: AccountAgentLinksCtrl
  });
